/**
 *
 * InsentCards
 *
 */

import PropTypes from 'prop-types';
import styled from 'styled-components';

const InsentCard = styled.div`
  i {
    cursor: pointer;
  }
  padding: ${props => props.padding || '24px'};
  background: ${p => (p.background ? p.background : p.theme.palette.white)};
  min-height: ${p => (p.connectToHuman ? '1px' : '100vh')};
  ${p => p.fullPage && 'min-width: 1248px;'}
  ${p => p.sideNavEnabled && 'min-width: 1086px;'}
  position: relative;
`;

const InsentCardHeader = styled.div`
  padding: 0 0 1rem !important;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  /* border-bottom: 1px solid ${props => props.theme.colors.borderColor}; */

  h4 {
    margin: 0;
  }
`;

const InsentCardBody = styled.div``;

InsentCard.propTypes = {
  error: PropTypes.bool,
};

export { InsentCard, InsentCardHeader, InsentCardBody };
